import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.character');
import { ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { FilesetResolver, FaceLandmarker, HandLandmarker, PoseLandmarker } from '@mediapipe/tasks-vision';
import { Face as KFace } from 'kalidokit';

const clamp = (v: number, min = 0, max = 1) => Math.min(max, Math.max(min, v));
const avg = (...vals: number[]) => {
    const f = vals.filter(v => Number.isFinite(v));
    return f.length === 0 ? 0 : f.reduce((s, v) => s + v, 0) / f.length;
};
const dist2d = (a: any, b: any) => Math.hypot((a?.x || 0) - (b?.x || 0), (a?.y || 0) - (b?.y || 0));

const FACE_DRAW_STEP = 8;
const HAND_CONNECTIONS = [
    [0, 1], [1, 2], [2, 3], [3, 4], [0, 5], [5, 6], [6, 7], [7, 8],
    [5, 9], [9, 10], [10, 11], [11, 12], [9, 13], [13, 14], [14, 15], [15, 16],
    [13, 17], [17, 18], [18, 19], [19, 20], [0, 17],
];
const POSE_CONNECTIONS = [[11, 12], [11, 13], [13, 15], [12, 14], [14, 16]];

const WS_URL = 'wss://virtual.character.seasonai.net/ws/character';

@Component({
    selector: 'wiz-page-character',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.character/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

/* ── Twitch Color Tokens ── */
/* ── Page ── */
.twitch-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #0e0e10;
  color: #efeff1;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ── Top Bar ── */
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 16px;
  background: #18181b;
  border-bottom: 1px solid #2f2f35;
  flex-shrink: 0;
}
.top-bar__left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.top-bar__right {
  display: flex;
  align-items: center;
  gap: 16px;
}
.top-bar__logo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #efeff1;
}
.top-bar__logo svg {
  color: #9146ff;
}
.top-bar__badge {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 2px 8px;
  border-radius: 4px;
  background: #26262c;
  color: #53535f;
}
.top-bar__badge--live {
  background: #eb0400;
  color: white;
}
.top-bar__stat {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #adadb8;
}
.top-bar__stat-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #53535f;
}
.top-bar__stat-dot--active {
  background: #eb0400;
  animation: pulse 1.5s infinite;
}
.top-bar__stat-dot--ws {
  background: #00e676;
}

/* ── Main Content ── */
.main-content {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

/* ── Stream Area ── */
.stream-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.stream-container {
  flex: 1;
  position: relative;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stream-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.stream-placeholder__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
  padding: 32px;
}
.stream-placeholder__icon {
  color: #53535f;
}
.stream-placeholder__title {
  font-size: 18px;
  font-weight: 600;
  color: #efeff1;
}
.stream-placeholder__desc {
  font-size: 13px;
  color: #adadb8;
  max-width: 320px;
  line-height: 1.5;
}

.stream-iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.stream-connected {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  height: 100%;
}
.stream-connected__pulse {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(145, 70, 255, 0.3);
  animation: pulse-ring 2s infinite;
}
.stream-connected p {
  font-size: 14px;
  color: #adadb8;
}

.stream-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: #18181b;
  border-top: 1px solid #2f2f35;
}
.stream-info__left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.stream-info__right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.stream-info__title {
  font-size: 14px;
  font-weight: 600;
  color: #efeff1;
}
.stream-info__category {
  font-size: 12px;
  color: #bf94ff;
}
.stream-info__viewers {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #adadb8;
}
.stream-info__viewers svg {
  color: #eb0400;
}

/* ── Right Panel ── */
.panel {
  width: 340px;
  background: #18181b;
  border-left: 1px solid #2f2f35;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px;
  flex-shrink: 0;
}

.panel-card {
  background: #1f1f23;
  border-radius: 8px;
  overflow: hidden;
}
.panel-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px 8px;
}
.panel-card__header h3 {
  font-size: 13px;
  font-weight: 600;
  color: #efeff1;
}
.panel-card__indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #53535f;
}
.panel-card__indicator--on {
  background: #00e676;
}
.panel-card__body {
  padding: 0 14px 12px;
}
.panel-card__actions {
  margin-top: 10px;
  display: flex;
  gap: 8px;
}
.panel-card--preview {
  padding: 0;
}
.panel-card--preview .panel-card__body {
  padding: 0;
}

.status-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}
.status-row__label {
  font-size: 12px;
  color: #53535f;
}
.status-row__value {
  font-size: 12px;
  color: #adadb8;
}
.status-row__value--on {
  color: #00e676;
}
.status-row__value--off {
  color: #53535f;
}
.status-row__value--warn {
  color: #ff8c00;
}
.status-row__value--error {
  color: #eb0400;
  font-size: 11px;
}
.status-row__value--mono {
  font-family: "JetBrains Mono", monospace;
  font-size: 11px;
}

/* ── Webcam Preview ── */
.webcam-preview {
  position: relative;
  aspect-ratio: 16/9;
  background: #000;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}
.webcam-preview__video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scaleX(-1);
}
.webcam-preview__overlay {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  transform: scaleX(-1);
}
.webcam-preview__badge {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  gap: 5px;
  background: #eb0400;
  color: white;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 4px;
  text-transform: uppercase;
}
.webcam-preview__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: white;
  animation: pulse 1.5s infinite;
}

/* ── Buttons ── */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
}
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn--primary {
  background: #9146ff;
  color: white;
}
.btn--primary:hover:not(:disabled) {
  background: #772ce8;
}
.btn--danger {
  background: rgba(235, 4, 0, 0.15);
  color: #eb0400;
}
.btn--danger:hover:not(:disabled) {
  background: rgba(235, 4, 0, 0.25);
}
.btn--sm {
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 4px;
}

/* ── Animations ── */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
@keyframes pulse-ring {
  0% {
    transform: scale(0.8);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.2;
  }
  100% {
    transform: scale(0.8);
    opacity: 0.6;
  }
}
/* ── Responsive ── */
@media (max-width: 1024px) {
  .panel {
    display: none;
  }
}`],
})
export class PageCharacterComponent implements OnInit, OnDestroy {
    @ViewChild('webcam') webcamRef?: ElementRef<HTMLVideoElement>;
    @ViewChild('overlay') overlayRef?: ElementRef<HTMLCanvasElement>;

    /* ── Camera ── */
    public webcamEnabled = false;
    public cameraBusy = false;
    public cameraStatus = 'offline';
    private stream: MediaStream | null = null;

    /* ── Tracking ── */
    public trackerLoading = true;
    public trackerReady = false;
    public trackingActive = false;
    public trackingFps = 0;
    public trackerError = '';

    /* ── WebSocket ── */
    public wsConnected = false;
    public wsConnecting = false;
    public wsRate = 0;
    public wsStatus = 'Disconnected';
    public wsError = '';

    /* ── Unity Stream ── */
    public unityStreamUrl = '';
    public unityConnected = false;

    /* ── Private: Tracker ── */
    private faceLM: any = null;
    private handLM: any = null;
    private poseLM: any = null;
    private animFrame: number | null = null;
    private lastVidTime = -1;
    private fpsCount = 0;
    private fpsTick = 0;

    /* ── Private: WebSocket ── */
    private ws: WebSocket | null = null;
    private wsLastSent = 0;
    private wsPktCount = 0;
    private wsFpsTick = 0;
    private wsReconnectTimer: any = null;
    private wsWasConnected = false;

    constructor(@Inject( Service) public service: Service) { }

    /* ═══════════ Lifecycle ═══════════ */

    public async ngOnInit() {
        await this.service.init();
        this.initTracker();
        await this.service.render();
    }

    public ngOnDestroy() {
        this.stopLoop();
        this.disconnectWs();
        this.releaseCamera();
        if (this.wsReconnectTimer) {
            clearTimeout(this.wsReconnectTimer);
        }
    }

    /* ═══════════ Tracker Init ═══════════ */

    private async initTracker() {
        try {
            const wasm = await FilesetResolver.forVisionTasks('/assets/mediapipe-wasm');
            const gpu = { delegate: 'GPU' as const };

            const [face, hand, pose] = await Promise.all([
                FaceLandmarker.createFromOptions(wasm, {
                    baseOptions: { ...gpu, modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/latest/face_landmarker.task' },
                    runningMode: 'VIDEO', numFaces: 1, outputFaceBlendshapes: true, outputFacialTransformationMatrixes: true,
                }),
                HandLandmarker.createFromOptions(wasm, {
                    baseOptions: { ...gpu, modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/hand_landmarker/hand_landmarker/float16/latest/hand_landmarker.task' },
                    runningMode: 'VIDEO', numHands: 2,
                }),
                PoseLandmarker.createFromOptions(wasm, {
                    baseOptions: { ...gpu, modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_full/float16/latest/pose_landmarker_full.task' },
                    runningMode: 'VIDEO', numPoses: 1,
                }),
            ]);

            this.faceLM = face;
            this.handLM = hand;
            this.poseLM = pose;
            this.trackerReady = true;
            this.trackerError = '';
        } catch (e: any) {
            console.error('Tracker init failed:', e);
            this.trackerError = e?.message || 'MediaPipe 모델 로드 실패';
        } finally {
            this.trackerLoading = false;
            await this.service.render();
        }
    }

    /* ═══════════ Camera ═══════════ */

    public async toggleWebcam() {
        if (this.cameraBusy) return;

        if (this.webcamEnabled) {
            this.stopLoop();
            this.releaseCamera();
            await this.service.render();
            return;
        }

        this.cameraBusy = true;
        this.cameraStatus = 'connecting';
        await this.service.render();

        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: false,
                video: { facingMode: 'user', width: { ideal: 1280 }, height: { ideal: 720 } },
            });
            this.stream = stream;
            this.webcamEnabled = true;
            this.cameraStatus = 'live';

            const video = this.webcamRef?.nativeElement;
            if (video) {
                video.srcObject = stream;
                await video.play();
            }

            if (this.trackerReady) {
                this.startLoop();
            }
        } catch (e: any) {
            this.webcamEnabled = false;
            this.cameraStatus = 'error';
        } finally {
            this.cameraBusy = false;
            await this.service.render();
        }
    }

    private releaseCamera() {
        if (this.stream) {
            this.stream.getTracks().forEach(t => t.stop());
            this.stream = null;
        }
        const video = this.webcamRef?.nativeElement;
        if (video) { video.pause(); video.srcObject = null; }
        this.webcamEnabled = false;
        this.cameraBusy = false;
        this.cameraStatus = 'offline';
        this.trackingActive = false;
        this.trackingFps = 0;
    }

    /* ═══════════ WebSocket ═══════════ */

    public async connectWs() {
        if (this.wsConnected || this.wsConnecting) return;
        this.wsConnecting = true;
        this.wsStatus = 'Connecting...';
        this.wsError = '';
        await this.service.render();

        try {
            await new Promise<void>((resolve, reject) => {
                const socket = new WebSocket(WS_URL);
                const timeout = setTimeout(() => {
                    socket.close();
                    reject(new Error('Connection timeout'));
                }, 8000);

                socket.addEventListener('open', () => {
                    clearTimeout(timeout);
                    this.ws = socket;
                    this.wsConnected = true;
                    this.wsConnecting = false;
                    this.wsWasConnected = true;
                    this.wsStatus = 'Connected';
                    this.wsError = '';
                    // Register as web client
                    socket.send(JSON.stringify({ type: 'register', role: 'web' }));
                    this.service.render();
                    resolve();
                }, { once: true });
                socket.addEventListener('error', () => {
                    clearTimeout(timeout);
                    this.wsConnecting = false;
                    this.wsStatus = 'Failed';
                    this.wsError = '서버에 연결할 수 없습니다.';
                    reject(new Error('WebSocket connection failed'));
                }, { once: true });
                socket.addEventListener('close', () => {
                    const wasConnected = this.wsConnected;
                    this.ws = null;
                    this.wsConnected = false;
                    this.wsRate = 0;
                    this.unityConnected = false;
                    this.wsStatus = 'Disconnected';
                    this.service.render();
                    if (wasConnected && this.wsWasConnected) {
                        this.scheduleReconnect();
                    }
                });
                socket.addEventListener('message', (event: MessageEvent) => {
                    this.handleUnityMessage(event.data);
                });
            });
        } catch (e: any) {
            this.wsConnecting = false;
            this.wsStatus = 'Failed';
            this.wsError = '서버에 연결할 수 없습니다. Unity 서버가 실행 중인지 확인하세요.';
        }
        await this.service.render();
    }

    public async disconnectWs() {
        this.wsWasConnected = false;
        if (this.wsReconnectTimer) {
            clearTimeout(this.wsReconnectTimer);
            this.wsReconnectTimer = null;
        }
        if (this.ws) this.ws.close();
        this.ws = null;
        this.wsConnected = false;
        this.wsRate = 0;
        this.wsConnecting = false;
        this.unityConnected = false;
        this.wsStatus = 'Disconnected';
        this.wsError = '';
        await this.service.render();
    }

    private scheduleReconnect() {
        if (this.wsReconnectTimer) return;
        this.wsStatus = 'Reconnecting...';
        this.service.render();
        this.wsReconnectTimer = setTimeout(() => {
            this.wsReconnectTimer = null;
            if (!this.wsConnected && this.wsWasConnected) {
                this.connectWs();
            }
        }, 5000);
    }

    private handleUnityMessage(data: string) {
        try {
            const msg = JSON.parse(data);
            if (msg.type === 'stream_url') {
                this.unityStreamUrl = msg.url;
                this.service.render();
            } else if (msg.type === 'status') {
                if (msg.state === 'unity_connected') {
                    this.unityConnected = true;
                } else if (msg.state === 'unity_disconnected') {
                    this.unityConnected = false;
                }
                this.service.render();
            }
        } catch (e) { }
    }

    /* ═══════════ Tracking Loop ═══════════ */

    private startLoop() {
        if (this.trackingActive) return;
        this.trackingActive = true;
        this.lastVidTime = -1;
        this.fpsCount = 0;
        this.fpsTick = performance.now();
        this.trackingLoop();
    }

    private stopLoop() {
        this.trackingActive = false;
        if (this.animFrame != null) {
            cancelAnimationFrame(this.animFrame);
            this.animFrame = null;
        }
        this.clearOverlay();
    }

    private trackingLoop = () => {
        if (!this.trackingActive) return;
        const video = this.webcamRef?.nativeElement;
        if (video && video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA && video.currentTime !== this.lastVidTime) {
            this.lastVidTime = video.currentTime;
            const ts = performance.now();
            const faceRes = this.faceLM.detectForVideo(video, ts);
            const handRes = this.handLM.detectForVideo(video, ts);
            const poseRes = this.poseLM.detectForVideo(video, ts);
            const frame = this.buildFrame(faceRes, handRes, poseRes, ts);
            this.drawOverlay(frame);
            this.sendFrame(frame);

            this.fpsCount++;
            if (ts - this.fpsTick >= 1000) {
                this.trackingFps = this.fpsCount;
                this.fpsCount = 0;
                this.fpsTick = ts;
                this.service.render();
            }
        }
        this.animFrame = requestAnimationFrame(this.trackingLoop);
    };

    /* ═══════════ Frame Building ═══════════ */

    private buildFrame(faceRes: any, handRes: any, poseRes: any, ts: number) {
        const faceLandmarks = faceRes?.faceLandmarks?.[0] || [];
        const found = faceLandmarks.length > 0;
        let head = { pitch: 0, yaw: 0, roll: 0 };
        let mouth = { A: 0, I: 0, U: 0, E: 0, O: 0 };
        let eyes: any = { Blink_L: 0, Blink_R: 0, blink: 0 };
        let look = { LookLeft: 0, LookRight: 0, LookUp: 0, LookDown: 0 };
        let expressions = { Joy: 0, Angry: 0, Sorrow: 0, Fun: 0, Neutral: 1 };
        let blendshapes: Record<string, number> = {};

        if (found) {
            const cats = faceRes.faceBlendshapes?.[0]?.categories || [];
            blendshapes = cats.reduce((m: any, c: any) => { m[c.categoryName] = c.score; return m; }, {});

            try {
                const video = this.webcamRef?.nativeElement;
                const rigged = KFace.solve(faceLandmarks, { runtime: 'mediapipe', video });

                head = {
                    pitch: clamp((rigged?.head?.x ?? 0) * 1.1, -0.85, 0.85),
                    yaw: clamp((rigged?.head?.y ?? 0) * 1.15, -1.2, 1.2),
                    roll: clamp((rigged?.head?.z ?? 0) * 1.1, -0.85, 0.85),
                };

                const shape = rigged?.mouth?.shape || {};
                mouth = {
                    A: clamp(Math.max(shape.A || 0, (blendshapes.jawOpen || 0) * 0.92)),
                    I: clamp(shape.I || 0),
                    U: clamp(Math.max(shape.U || 0, (blendshapes.mouthPucker || 0) * 0.8, (blendshapes.mouthFunnel || 0) * 0.42)),
                    E: clamp(shape.E || 0),
                    O: clamp(Math.max(shape.O || 0, (blendshapes.mouthFunnel || 0) * 0.9)),
                };

                const blinkL = clamp(1 - (rigged?.eye?.l ?? 1));
                const blinkR = clamp(1 - (rigged?.eye?.r ?? 1));
                eyes = {
                    Blink_L: clamp(Math.max(blinkL, blendshapes.eyeBlinkLeft || 0)),
                    Blink_R: clamp(Math.max(blinkR, blendshapes.eyeBlinkRight || 0)),
                    blink: avg(clamp(Math.max(blinkL, blendshapes.eyeBlinkLeft || 0)), clamp(Math.max(blinkR, blendshapes.eyeBlinkRight || 0))),
                };

                const px = rigged?.pupil?.x ?? 0;
                const py = rigged?.pupil?.y ?? 0;
                look = {
                    LookLeft: clamp(Math.max(0, -px) * 1.4),
                    LookRight: clamp(Math.max(0, px) * 1.4),
                    LookUp: clamp(Math.max(0, py) * 1.35),
                    LookDown: clamp(Math.max(0, -py) * 1.35),
                };

                const joy = avg(blendshapes.mouthSmileLeft, blendshapes.mouthSmileRight, blendshapes.cheekSquintLeft, blendshapes.cheekSquintRight);
                const angry = avg(blendshapes.browDownLeft, blendshapes.browDownRight, blendshapes.noseSneerLeft, blendshapes.noseSneerRight);
                const sorrow = avg(blendshapes.mouthFrownLeft, blendshapes.mouthFrownRight, blendshapes.innerBrowUp);
                const fun = avg(blendshapes.cheekSquintLeft, blendshapes.cheekSquintRight, mouth.A * 0.7 + mouth.E * 0.5);
                expressions = {
                    Joy: clamp(joy), Angry: clamp(angry), Sorrow: clamp(sorrow), Fun: clamp(fun),
                    Neutral: clamp(1 - Math.max(joy, angry, sorrow, fun)),
                };
            } catch (e) {
                console.warn('Face solve failed:', e);
            }
        }

        const handLandmarks = handRes?.landmarks || [];
        const handedness = handRes?.handedness || [];
        const hands = handLandmarks.map((lm: any[], i: number) => {
            const label = handedness[i]?.[0]?.categoryName || `Hand${i + 1}`;
            const wrist = lm[0];
            const thumbOpen = label === 'Left' ? lm[4].x < lm[3].x : lm[4].x > lm[3].x;
            const ext = (tip: number, pip: number) => lm[tip].y < lm[pip].y;
            return {
                handedness: label,
                landmarks: lm,
                fingers: {
                    thumb: Boolean(thumbOpen),
                    index: ext(8, 6), middle: ext(12, 10), ring: ext(16, 14), pinky: ext(20, 18),
                    openness: clamp(avg(
                        dist2d(lm[8], wrist) / Math.max(dist2d(lm[5], wrist), 1e-4),
                        dist2d(lm[12], wrist) / Math.max(dist2d(lm[9], wrist), 1e-4),
                        dist2d(lm[16], wrist) / Math.max(dist2d(lm[13], wrist), 1e-4),
                        dist2d(lm[20], wrist) / Math.max(dist2d(lm[17], wrist), 1e-4),
                    ) / 1.8),
                },
            };
        });

        const poseLm = poseRes?.landmarks?.[0] || [];
        const poseFound = poseLm.length > 0;
        let shoulders: any = { roll: 0, span: 0, center: { x: 0, y: 0 } };
        if (poseFound) {
            const ls = poseLm[11];
            const rs = poseLm[12];
            shoulders = {
                left: ls, right: rs,
                roll: Math.atan2((rs?.y || 0) - (ls?.y || 0), (rs?.x || 0) - (ls?.x || 0)),
                span: dist2d(ls, rs),
                center: { x: avg(ls?.x, rs?.x), y: avg(ls?.y, rs?.y) },
            };
        }

        return {
            timestamp: ts,
            face: { found, head, mouth, eyes, look, expressions, blendshapes, landmarks: faceLandmarks },
            hands,
            pose: { found: poseFound, shoulders, landmarks: poseLm },
        };
    }

    /* ═══════════ Debug Overlay ═══════════ */

    private drawOverlay(frame: any) {
        const canvas = this.overlayRef?.nativeElement;
        const video = this.webcamRef?.nativeElement;
        if (!canvas || !video) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        canvas.width = video.videoWidth || 1280;
        canvas.height = video.videoHeight || 720;
        const w = canvas.width;
        const h = canvas.height;
        ctx.clearRect(0, 0, w, h);

        const mp = (p: any) => ({ x: p.x * w, y: p.y * h });

        if (frame.face?.landmarks?.length) {
            ctx.fillStyle = 'rgba(169,112,255,0.85)';
            frame.face.landmarks.forEach((p: any, i: number) => {
                if (i % FACE_DRAW_STEP === 0) {
                    const { x, y } = mp(p);
                    ctx.beginPath(); ctx.arc(x, y, 1.8, 0, Math.PI * 2); ctx.fill();
                }
            });
        }

        frame.hands.forEach((hand: any) => {
            ctx.strokeStyle = 'rgba(255,183,77,0.95)'; ctx.lineWidth = 1.6;
            HAND_CONNECTIONS.forEach(([f, t]: number[]) => {
                const a = mp(hand.landmarks[f]), b = mp(hand.landmarks[t]);
                ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
            });
            ctx.fillStyle = 'rgba(255,183,77,0.95)';
            hand.landmarks.forEach((p: any) => {
                const { x, y } = mp(p);
                ctx.beginPath(); ctx.arc(x, y, 2.4, 0, Math.PI * 2); ctx.fill();
            });
        });

        if (frame.pose?.landmarks?.length) {
            ctx.strokeStyle = 'rgba(0,230,118,0.9)'; ctx.lineWidth = 2;
            POSE_CONNECTIONS.forEach(([f, t]: number[]) => {
                const a = mp(frame.pose.landmarks[f]), b = mp(frame.pose.landmarks[t]);
                ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
            });
            ctx.fillStyle = 'rgba(0,230,118,0.95)';
            [11, 12, 13, 14, 15, 16].forEach((i: number) => {
                const p = frame.pose.landmarks[i];
                if (p) {
                    const { x, y } = mp(p);
                    ctx.beginPath(); ctx.arc(x, y, 3.2, 0, Math.PI * 2); ctx.fill();
                }
            });
        }
    }

    private clearOverlay() {
        const canvas = this.overlayRef?.nativeElement;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    /* ═══════════ WebSocket Send ═══════════ */

    private sendFrame(frame: any) {
        if (!this.wsConnected || !this.ws || this.ws.readyState !== WebSocket.OPEN) return;
        const now = Date.now();
        if (now - this.wsLastSent < 33) return;
        this.wsLastSent = now;

        this.wsPktCount++;
        if (now - this.wsFpsTick >= 1000) {
            this.wsRate = this.wsPktCount;
            this.wsPktCount = 0;
            this.wsFpsTick = now;
        }

        const payload = {
            type: 'tracking',
            timestamp: now,
            tracking: {
                face: {
                    found: frame.face.found,
                    head: frame.face.head,
                    mouth: frame.face.mouth,
                    eyes: frame.face.eyes,
                    look: frame.face.look,
                    expressions: frame.face.expressions,
                },
                hands: frame.hands.map((h: any) => ({
                    handedness: h.handedness,
                    fingers: h.fingers,
                    landmarks: h.landmarks,
                })),
                pose: {
                    found: frame.pose.found,
                    shoulders: frame.pose.shoulders,
                },
            },
        };
        this.ws.send(JSON.stringify(payload));
    }
}

export default PageCharacterComponent;